import { render, staticRenderFns } from "./MpMendelejewV2.vue?vue&type=template&id=719716fe&scoped=true&"
import script from "./MpMendelejewV2.vue?vue&type=script&lang=js&"
export * from "./MpMendelejewV2.vue?vue&type=script&lang=js&"
import style1 from "./MpMendelejewV2.vue?vue&type=style&index=1&id=719716fe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "719716fe",
  null
  
)

export default component.exports